import { inputTypes } from '../helpers/enums';

export const statusOptions = [
  { value: 'pending', label: 'Pending' },
  { value: 'active', label: 'Active' },
  { value: 'completed', label: 'Completed' },
];

export const newProjectForm = {
  name: {
    label: 'Name',
    type: inputTypes.text,
    placeholder: 'Enter name',
    validation: {
      required: true,
      minLength: 2
    }
  },
  status: {
    label: 'Status',
    type: inputTypes.select,
    placeholder: 'Select status',
    options: statusOptions,
    validation: {
      required: true
    }
  },
  users: {
    label: 'Users',
    type: inputTypes.usersSelect,
  },
};

export const newProjectForm_payments = {
  payments: {
    type: inputTypes.multiple,
    isDynamic: true,
    confirmBeforeDeleting: true,
    childs: {
      paidAt: {
        label: 'Paid at',
        type: inputTypes.date,
        placeholder: 'Enter date',
        validation: {
          required: true
        }
      },
      paidAmount: {
        label: 'Paid amount',
        type: inputTypes.number,
        placeholder: 'Enter amount',
        validation: {
          required: true
        }
      },
      paidHours: {
        label: 'Paid hours',
        type: inputTypes.number,
        placeholder: 'Enter hours',
        validation: {
          required: true
        }
      },
      hourlyRate: {
        label: 'Hourly rate',
        type: inputTypes.number,
        placeholder: 'Enter rate',
        validation: {
          required: true
        }
      },
    }
  }
};

export const newProjectForm_credits = {
  credits: {
    type: inputTypes.multiple,
    isDynamic: true,
    confirmBeforeDeleting: true,
    childs: {
      givenAt: {
        label: 'Given at',
        type: inputTypes.date,
        placeholder: 'Enter date',
        validation: {
          required: true
        }
      },
      creditAmount: {
        label: 'Credit amount',
        type: inputTypes.number,
        placeholder: 'Enter amount',
        validation: {
          required: true
        }
      },
      creditHours: {
        label: 'Credit hours',
        type: inputTypes.number,
        placeholder: 'Enter hours',
        validation: {
          required: true
        }
      },
      note: {
        label: 'Note',
        type: inputTypes.text,
        placeholder: 'Enter note',
        validation: {
          required: true
        }
      }
    }
  }
};
